import React from 'react'
import BackToTop from '../BackTop'
import { Link } from 'react-router-dom'
import Logo from '../../assets/logo192.png'


function Footer() {
  return (
    <footer>
        <div className="container flex">
            <Link to='/'>
            <img src={Logo} alt="Congolese Design" width="60" />
            </Link>
            <small className="small-light">
                &copy; {new Date().getFullYear()} Congolese Design | Prince Mwenyemali.
            </small>
            <div className="divider">
              <div className="v-la vida"></div>
              <div className="v-pri vida"></div>
              <div className="v-la vida"></div>
            </div>
            <small className="small-primary">
              Dedicated to Innovation, Communication, and Quality Execution
            </small>
            <small className="small-light">
              All images are property of <Link to="https://www.freepik.com/app" className='small-light' target='_blank' rel='noopener noreferer'>FreePik.com</Link>
            </small>
        </div>
        <BackToTop/>
    </footer>
  )
}

export default Footer